<template>
  <span v-resize="checkMobile">
    <loading
      :active.sync="isLoading"
      :is-full-page="true"
      color="#1976d2"
      :background-color="$vuetify.theme.dark ? '#000' : ''"
    ></loading>
    <!-- <v-row justify="center" align="center"> -->
    <v-flex xs12 sm6 class="mx-auto">
      <v-card>
        <!-- <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">
                {{ $t("custom.editing") }}: {{ user.email }}
              </h3>
            </div>
          </v-card-title> -->
        <v-card-text>
          <v-text-field
            :label="$t('custom.email')"
            v-model.trim="user.email"
            :disabled="true"
          ></v-text-field>
          <v-text-field
            v-model="user.name"
            :placeholder="$t('employers.nickname')"
            :label="$t('employers.nickname')"
            :disabled="!(user.id == current_user_id) || !checkAdminManager()"
          ></v-text-field>
          <v-text-field
            v-model="user.first_name"
            :placeholder="$t('employers.name')"
            :label="$t('employers.name')"
            :disabled="!(user.id == current_user_id) || !checkAdminManager()"
          ></v-text-field>
          <v-text-field
            v-model="user.middle_name"
            :placeholder="$t('employers.middle_name')"
            :label="$t('employers.middle_name')"
            :disabled="!(user.id == current_user_id) || !checkAdminManager()"
          ></v-text-field>
          <v-text-field
            v-model="user.last_name"
            :placeholder="$t('employers.last_name')"
            :label="$t('employers.last_name')"
            :disabled="!(user.id == current_user_id) || !checkAdminManager()"
          ></v-text-field>
          <v-select
            :items="
              isSuperAdmin || isGuest
                ? super_roles
                : roles
            "
            v-model="user.role"
            :disabled="!checkAdmin()"
            :label="$t('other.role')"
          ></v-select>
          <v-text-field
            v-model.trim="user.partner_id"
            :placeholder="$t('partners.partner_id')"
            :label="$t('partners.partner_id')"
            v-if="user.role == 'partner'"
            :disabled="!checkAdminManager()"
          ></v-text-field>
          <v-switch
            v-if="checkSuperAdmin()"
            @change="update"
            v-model="user.can_change_branch"
            :label="$t('users.can_change_branch')"
            class="mr-2 my-auto"
            hide-details
            dense
          ></v-switch>
        </v-card-text>

        <v-card-actions class="justify-center">
          <v-flex md12 :class="isMobile ? '' : 'd-flex justify-center text-center'">
            <v-flex>
              <v-btn
                v-if="checkAdminManager()"
                text
                @click="update"
                color="success"
                >{{ $t("custom.save") }}
              </v-btn>
            </v-flex>
            <v-flex v-if="(checkAdmin() || user_role == 'guest') && user.active">
              <v-btn
                text
                color="warning"
                @click="saveUserActive(false)"
                >{{ $t("employers.dismiss") }}
              </v-btn>
            </v-flex>
            <v-flex v-if="(checkAdmin() || user_role == 'guest') && !user.active">
              <v-btn
                text
                color="success"
                @click="saveUserActive(true)"
              >
                {{ $t("custom.activate") }}
              </v-btn>
            </v-flex>
            <v-flex>
              <v-btn class="mx-auto" text to="/admin/users">{{
                $t("employers.all")
              }}</v-btn>
            </v-flex>
          </v-flex>
        </v-card-actions>
      </v-card>
    </v-flex>
    <!-- </v-row> -->
    <SeatLimitDialog
      v-model="seatPaywall.show"
      :info="seatPaywall.info"
      :busy="seatPaywall.busy"
      @buy="buyExtraUser(() => saveUserActive(true), $event)"
      @to-tariff="seatPaywallToTariff"
    />
  </span>
</template>

<script>
import seatPaywall from "@/mixins/seatPaywall";
import SeatLimitDialog from "@/components/common/SeatLimitDialog.vue";
export default {
  name: "UserEdit",
  mixins: [seatPaywall],
  components: { SeatLimitDialog },
  data() {
    return {
      error: "",
      notice: "",
      user: {
        role: null,
        email: null,
        name: null,
        active: true,
        can_change_branch: false,
      },
      roles: [
        { text: this.$t("employers.employee"), value: "user" },
        { text: this.$t("employers.manager"), value: "manager" },
        { text: this.$t("employers.admin"), value: "admin" },
        { text: this.$t("employers.partner"), value: "partner" },
        { text: this.$t("employers.guest"), value: "guest" },
      ],
      super_roles: [
        { text: this.$t("employers.employee"), value: "user" },
        { text: this.$t("employers.manager"), value: "manager" },
        { text: this.$t("employers.admin"), value: "admin" },
        { text: this.$t("employers.superadmin"), value: "superadmin" },
        { text: this.$t("employers.partner"), value: "partner" },
        { text: this.$t("employers.guest"), value: "guest" },
      ],
      isLoading: false,
      isMobile: false,
    };
  },
  mounted() {
    let self = this;
  },
  created() {
    if (this.$store.getters.isLoggedIn) {
      this.isLoading = true;
      this.axios
        .get(`/admin/users/${this.$route.params.id}`, {
          headers: {
            Authorization: this.$store.getters.getAuthToken,
          },
        })
        .then((response) => {
          this.user = response.data;
        })
        .catch((error) => {
          this.isLoading = false;
          // 404 = пользователя нет (удалён / битый id): уводим на список вместо
          // пустой формы редактирования. Прочее — через setError.
          if (error.response?.status === 404) {
            this.$notify(this.$t("errors.user_not_found"), "", "error");
            this.$router.push({ path: `/admin/users` });
            return;
          }
          this.setError(error, this.$t("errors.load_user"));
        })
        .finally(() => (this.isLoading = false));
    } else {
      this.$store.commit("unsetCurrentUser");
    }
  },
  computed: {
    current_user_id() {
      if (this.$store.getters.getCurrentUser) {
        return this.$store.getters.getCurrentUser.id;
      } else {
        return "";
      }
    },
  },
  methods: {
    update() {
      if (this.isStaff) {
        this.isLoading = true;
        this.axios
          .patch(
            `/admin/users/${this.$route.params.id}`,
            {
              user: {
                role: this.user.role,
                name: this.user.name,
                last_name: this.user.last_name,
                middle_name: this.user.middle_name,
                first_name: this.user.first_name,
                partner_id: this.user.partner_id,
                can_change_branch: this.user.can_change_branch,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.$notify(this.$t("users.user_update_success_title"), this.$t("users.user_update_success_text"), "success", 3000);
          })
          .catch((error) => {
            this.isLoading = false;
            // 406 — снятие роли с себя (старый контракт); last_superadmin — понижение
            // последнего владельца чужими руками (инцидент 2026-08-06). Смысл один.
            if (error.response?.status == 406 || error?.response?.data?.error === "last_superadmin") {
              this.setError(error, this.$t("errors.must_be_one_superadmin"));
            } else {
              this.setError(error, this.$t("errors.error"));
            }
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.only_admins"), "", "warning", 3000);
      }
    },
    saveUserActive(state) {
      if (this.checkAdmin()) {
        this.isLoading = true;
        this.axios
          .patch(
            `/admin/users/${this.$route.params.id}`,
            {
              user: {
                active: state,
              },
            },
            {
              headers: {
                Authorization: this.$store.getters.getAuthToken,
              },
            }
          )
          .then(() => {
            this.user.active = state;
            this.$notify(this.$t("users.user_update_success_title"), this.$t("users.user_update_success_text"), "success", 3000);
          })
          .catch((error) => {
            // FT-077: реактивация сверх лимита → seat-пейвол (ретрай активации после покупки места).
            if (this.maybeSeatPaywall(error)) return;
            // Деактивация последнего активного суперадмина филиала — иначе владелец
            // отключал сам себя и терял доступ (инцидент 2026-08-06).
            if (error?.response?.data?.error === "last_superadmin") {
              this.setError(error, this.$t("errors.must_be_one_superadmin"));
              return;
            }
            this.setError(error, this.$t("errors.error"));
            console.log(error);
          })
          .finally(() => (this.isLoading = false));
      } else {
        this.$notify(this.$t("errors.only_admins"), "", "warning", 3000);
      }
    },
    checkMobile() {
      if (this.$vuetify.breakpoint.name == "xs" || this.$vuetify.breakpoint.name == "sm") {
        this.isMobile = true;
        return true;
      } else {
        this.isMobile = false;
        return false;
      }
    },
    checkAdminManager() {
      return (
        this.$store.getters.isSuperAdmin ||
        this.$store.getters.isAdmin ||
        this.$store.getters.isManager
      );
    },
    checkAdmin() {
      return this.$store.getters.isSuperAdmin || this.$store.getters.isAdmin;
    },
    checkSuperAdmin() {
      return this.$store.getters.isSuperAdmin;
    },
  },
};
</script>
